module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-6.01578281.jpg";